import React from "react";
import styled from "styled-components";
import { NavLink, Link } from "react-router-dom";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

//Imgs
import { ReactComponent as PoweredMedialog } from "./../../Global/images/poweredByMedialog.svg";
import { ReactComponent as ChaseUpLogo } from "./../../Global/images/chaseupLogo.svg";

const StyledFooter = styled(NanoFlex)`
  height: auto;
  background-color: ${(props) => props.theme.color.primaryColors.lighterPurple};
  padding: 50px 150px;

  .footerTop {
    gap: 30px;
    position: relative;
    .brandContainer {
      height: auto;

      svg {
        height: 40px;
        width: auto;
      }
    }
    .footerShortcutList {
      gap: 100px;

      .footerShortcutCol {
        height: auto;
        width: auto;
        gap: 20px;
        width: 35%;

        a {
          cursor: pointer;
          transition: 0.4s all ease-in-out;
          text-decoration: none;
          color: ${(props) => props.theme.color.primaryColors.fontColor};
          user-select: none;
          text-transform: uppercase;

          &:hover {
            color: ${(props) => props.theme.color.primaryColors.darkPurple};
          }

          &:focus,
          &:focus-visible {
            color: ${(props) => props.theme.color.primaryColors.darkPurple};
            text-decoration: underline;
          }
          &:disabled,
          &.disabled {
            opacity: 0.4;
            pointer-events: none;
          }
        }
      }
    }

    .poweredByContainer {
      width: auto;
      height: auto;
      position: absolute;
      right: 0;
      bottom: 0;

      svg {
        height: 22px;
        width: auto;

        path {
          fill: ${(props) => props.theme.color.primaryColors.fontColor};
        }
      }
    }
  }
  @media only screen and (max-width: 1450px) {
    padding: 50px 100px;
  }

  @media only screen and (max-width: 1024px) {
    padding: 30px 60px;
    .poweredByContainer {
      svg {
        height: 18px;
      }
    }
  }

  @media only screen and (max-width: 815px) {
    padding: 24px 40px 50px 40px;

    .brandContainer {
      svg {
        height: 34px;
        width: auto;
      }
    }

    .footerTop {
      .poweredByContainer {
        bottom: -40px;
        svg {
          height: 15px;
          width: auto;
        }
      }
    }
  }

  @media only screen and (max-width: 390px) {
    padding: 24px 30px 39px 30px;

    .footerTop {
      .poweredByContainer {
        bottom: -25px;
      }
    }
  }
`;

export class Footer extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }
  render() {
    return (
      <StyledFooter className="footer" flexDirection="column">
        <NanoFlex className="footerTop" flexDirection="column">
          <NanoFlex className="brandContainer" justifyContent="flex-start">
            <ChaseUpLogo />
          </NanoFlex>
          <NanoFlex className="footerShortcutList" alignItems="flex-start" justifyContent="flex-start">
            <NanoFlex className="footerShortcutCol" flexDirection="column" alignItems="flex-start">
              <NanoFlex className="shortcutItem" justifyContent="flex-start">
                <NavLink to="/" exact={true}>
                  <Type.p className="medium">{this.translation.homepage.homepage}</Type.p>
                </NavLink>
              </NanoFlex>
              <NanoFlex className="shortcutItem" justifyContent="flex-start">
                <NavLink to="/about-us" exact={true}>
                  <Type.p className="medium">{this.translation.navBar.aboutUs}</Type.p>
                </NavLink>
              </NanoFlex>
              <NanoFlex className="shortcutItem" justifyContent="flex-start">
                <NavLink to="/recrutamento" exact={true}>
                  <Type.p className="medium">{this.translation.navBar.recruitment}</Type.p>
                </NavLink>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="footerShortcutCol" flexDirection="column" alignItems="flex-start">
              <NanoFlex className="shortcutItem" justifyContent="flex-start">
                <NavLink to="/assessment" exact={true}>
                  <Type.p className="medium">{this.translation.navBar.assessment}</Type.p>
                </NavLink>
              </NanoFlex>
              <NanoFlex className="shortcutItem" justifyContent="flex-start">
                <NavLink to="#contacts" exact={true}>
                  <Type.p className="medium">{this.translation.navBar.contacts}</Type.p>
                </NavLink>
              </NanoFlex>

              <NanoFlex className="shortcutItem" justifyContent="flex-start">
                <NavLink to="/privacy-policy" exact={true}>
                  <Type.p className="medium">{this.translation.contactForm.privacyPolicy}</Type.p>
                </NavLink>
              </NanoFlex>
            </NanoFlex>
            <NanoFlex className="poweredByContainer" justifyContent="flex-end" alignItems="flex-end">
              <NanoFlex>
                <a href="https://www.medialog.pt/" rel="noopener noreferrer" target="_blank">
                  <PoweredMedialog />
                </a>
              </NanoFlex>
            </NanoFlex>
          </NanoFlex>
        </NanoFlex>
      </StyledFooter>
    );
  }
}
